import {
  CalendarIcon,
  ExclamationCircleIcon,
  XIcon,
} from "@heroicons/react/solid";
import { useState } from "react";

import { MaintenanceMessage } from "pwapi";

const MaintenanceBanner = ({ m }: { m: MaintenanceMessage }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  return isOpen ? (
    <div className={`MaintenanceBanner MaintenanceBanner--${m.type}-bkg`}>
      {m.type === "alert" ? (
        <ExclamationCircleIcon
          className={`MaintenanceBanner--${m.type}-icon`}
        />
      ) : (
        <CalendarIcon className={`MaintenanceBanner--${m.type}-icon`} />
      )}
      <strong>{m.title}</strong>
      {m.message}
      <XIcon
        color="var(--gray)"
        onClick={() => setIsOpen(false)}
        className="MaintenanceBanner__closeControl"
      />
    </div>
  ) : null;
};

export default MaintenanceBanner;
